import { render, staticRenderFns } from "./RedesignDetailsPrise.vue?vue&type=template&id=cdbbc146&scoped=true"
import script from "./RedesignDetailsPrise.vue?vue&type=script&lang=js"
export * from "./RedesignDetailsPrise.vue?vue&type=script&lang=js"
import style0 from "./RedesignDetailsPrise.vue?vue&type=style&index=0&id=cdbbc146&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignDetailsPrise.vue?vue&type=style&index=1&id=cdbbc146&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbbc146",
  null
  
)

export default component.exports